<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    max-width="290"
    min-width="290"
    content-class="responsive-menu"
  >
    <template #activator="{ props }">
      <v-text-field
        :model-value="formattedDate"
        :label="label"
        readonly
        v-bind="props"
        variant="outlined"
        :required="isRequired"
        density="compact"
        hide-details
        append-inner-icon="mdi-calendar"
        :disabled="disabled"
        :rules="isRequired ? [required] : []"
      />
    </template>

    <v-date-picker
      v-model="internalDate"
      locale="ru"
      @update:modelValue="onDateSelected"
    />
  </v-menu>
</template>

<script>
export default {
  name: 'DatePickerField',
  props: {
    modelValue: [String, Date],
    label: String,
    disabled: Boolean,
    isRequired: Boolean,
    required: {
      type: Function,
      default: () => (v) => !!v || 'Это поле обязательно',
    }
  },
  data() {
    return {
      menu: false,
      internalDate: this.modelValue || null,
    }
  },
  watch: {
    modelValue(newVal) {
      this.internalDate = newVal
    }
  },
  computed: {
    formattedDate() {
      const dateOnlyMatch = typeof this.internalDate === 'string'
        ? this.internalDate.match(/^(\d{4})-(\d{2})-(\d{2})$/)
        : null

      if (dateOnlyMatch) {
        const [, year, month, day] = dateOnlyMatch
        return `${day}.${month}.${year}`
      }

      const date = typeof this.internalDate === 'string'
        ? new Date(this.internalDate)
        : this.internalDate

      if (!date || isNaN(date.getTime())) return ''

      const day = String(date.getDate()).padStart(2, '0')
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const year = date.getFullYear()
      return `${day}.${month}.${year}`
    }
  },
  methods: {
    onDateSelected(val) {
      this.menu = false

      if (!val) {
        this.$emit('update:modelValue', val)
        return
      }

      if (typeof val === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(val)) {
        this.$emit('update:modelValue', val)
        return
      }

      const date = val instanceof Date ? val : new Date(val)
      if (isNaN(date.getTime())) {
        this.$emit('update:modelValue', val)
        return
      }

      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      this.$emit('update:modelValue', `${year}-${month}-${day}`)
    }
  }
}
</script>
